var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrawerMenuSection = void 0;
var DrawerMenuSection_1 = __importDefault(require("./DrawerMenuSection"));
exports.DrawerMenuSection = DrawerMenuSection_1.default;
exports.default = DrawerMenuSection_1.default;
//# sourceMappingURL=index.js.map